"use strict";
/*
 * Created on Wed Nov 07 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var PromoSettingsConverter_1 = require("./conversions/PromoSettingsConverter");

var PromoSettingsConverterImpl_1 = require("./conversions/PromoSettingsConverterImpl");

var SegmentationModelConverter_1 = require("./conversions/SegmentationModelConverter");

var SegmentationModelConverterImpl_1 = require("./conversions/SegmentationModelConverterImpl");
/**
 * ZSr
 */


var PromoSettingsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PromoSettingsAppModule, _AppModule_1$AppModul);

  function PromoSettingsAppModule() {
    var _this;

    _classCallCheck(this, PromoSettingsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoSettingsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'settingsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromoSettingsAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PromoSettingsConverter_1.PromoSettingsConverter).to(PromoSettingsConverterImpl_1.PromoSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SegmentationModelConverter_1.SegmentationModelConverter).to(SegmentationModelConverterImpl_1.SegmentationModelConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PromoSettingsAppModule;
}(AppModule_1.AppModule);

exports.PromoSettingsAppModule = PromoSettingsAppModule;